import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import * as Yup from "yup";

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem("token");

const validationSchema = Yup.object({
    name: Yup.string().required("Le nom du rôle est obligatoire"),
});

const RoleManagement = () => {
    const [roles, setRoles] = useState([]);
    const [roleName, setRoleName] = useState("");
    const [selectedRole, setSelectedRole] = useState(null);

    useEffect(() => {
        fetchRoles();
    });

    const fetchRoles = () => {
        axiosInstance.get(`${baseUrl}/api/Roles`)
            .then(res => setRoles(res.data))
            .catch(() => console.log("Impossible de charger les données"));
    };

    const formik = useFormik({
        initialValues: {
            id: "",
            name: ""
        },
        validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {

            const url = values.id
                ? `${baseUrl}/api/Roles/UpdateRole`
                : `${baseUrl}/api/Roles/CreateRole`;

            const payload = {
                id: values.id || "",
                name: values.name
            };

            try {
                await axiosInstance.post(url, payload);

                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchRoles();
                resetForm();
                setSelectedRole(null);

            } catch (error) {

                // 🔴 erreurs serveur (ModelState / ServiceResponse)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });

    const handleEdit = (role) => {
        setSelectedRole(role);
        formik.setValues({
            id: role.id,
            name: role.name
        });

        setTimeout(() => {
            window.$("#modalForm").modal("show");
        }, 100);
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/Roles/DeleteRole`,
                    { 'id': 0, 'idString': id })
                    .then(() => fetchRoles())
                    .catch(() => Swal.fire("Erreur", "Suppression échouée", "error"));
            }
        });
    };

    const resetForm = () => {
        formik.resetForm();
        setSelectedRole(null);
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Rôles</h3>

            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" onClick={resetForm}><i className="fas fa-plus"></i>Ajouter</button>


            <DataTableComponent
                data={roles}
                title="Liste des Rôles"
                columns={["name"]}
                columnsMapping={{ name: "Nom" }}
                keyField="id"
                handleEdit={handleEdit}
                handleDelete={(id) => handleDelete(id)}
            />

            {/* Modal Form */}
            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedRole ? "Modifier" : "Ajouter"} un rôle</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group mb-3">
                                <label>Nom de rôle</label>
                                <input
                                    type="text"
                                    name="name"
                                    className={`form-control ${formik.touched.name && formik.errors.name ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">
                                    {formik.errors.name}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoleManagement;
